export default "__VITE_ASSET__7193fa57__"